import { postUpdateGameFreespin } from '../api/postUpdateGameFreespin';

const setPostUpdateGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateGameFreespin(params);
            alert('Игра обновлена')
        } catch(error) {
            alert('Ошибка добавления')
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateGameFreespin
}